/**
 * Temporary UI switch for cadastre parcel create/edit/delete.
 * Keep CRUD implementation in place and set this to `true` when the feature is ready to expose.
 */
export const CADASTRE_PARCEL_CRUD_ENABLED = false;
